import './App.css';
import { useState, useEffect } from 'react';

function App() {
  const buttonMessages = [
    "Hello...?",
    "ummm hi?",
    "what's going on",
    "is anyone there?",
    "hello??",
    "*nervous wave*"
  ];

  const mainMessages = [
    "i've been waiting for you...",
    "its me.",
    "you know,",
    "your boyfriend.",
    "LOL sorry for edging you",
    "i know you've been having a tough time",
    "but...",
    "i want you to know that...",
    "you are perfect.",
    "i love you.",
    "and i miss you",
    "so...",
    "enjoy this virtual hug ❤️"
  ];
  
  const [currentButtonIndex, setCurrentButtonIndex] = useState(0);
  const [buttonText, setButtonText] = useState('');
  const [showButton, setShowButton] = useState(true);
  const [mainText, setMainText] = useState("Hello Madeline");
  const [mainMessageIndex, setMainMessageIndex] = useState(0);
  const [isMainSequence, setIsMainSequence] = useState(false);
  const [isTyping, setIsTyping] = useState(true);
  const [showHearts, setShowHearts] = useState(false);

  // Button typing effect
  useEffect(() => {
    if (!isMainSequence) {
      const message = buttonMessages[currentButtonIndex];
      
      if (buttonText.length < message.length) {
        const timeoutId = setTimeout(() => {
          setButtonText(message.slice(0, buttonText.length + 1));
        }, 100);
        return () => clearTimeout(timeoutId);
      } else {
        const timeoutId = setTimeout(() => {
          setButtonText('');
          setCurrentButtonIndex((prev) => (prev + 1) % buttonMessages.length);
        }, 1000);
        return () => clearTimeout(timeoutId);
      }
    }
  }, [buttonText, currentButtonIndex, isMainSequence]);

  // Main message sequence
  useEffect(() => {
    if (isMainSequence) {
      const message = mainMessages[mainMessageIndex];
      
      if (isTyping) {
        if (mainText.length === 0) {
          const timeoutId = setTimeout(() => {
            setMainText(message[0] || '');
          }, 500);
          return () => clearTimeout(timeoutId);
        }
        
        if (mainText.length < message.length) {
          const timeoutId = setTimeout(() => {
            setMainText(message.slice(0, mainText.length + 1));
          }, 100);
          return () => clearTimeout(timeoutId);
        } else {
          const timeoutId = setTimeout(() => {
            setIsTyping(false);
          }, 2000);
          return () => clearTimeout(timeoutId);
        }
      } else {
        if (mainText.length > 0) {
          const timeoutId = setTimeout(() => {
            setMainText(mainText.slice(0, -1));
          }, 50);
          return () => clearTimeout(timeoutId);
        } else {
          if (mainMessageIndex < mainMessages.length - 1) {
            const timeoutId = setTimeout(() => {
              setMainMessageIndex(prev => prev + 1);
              setIsTyping(true);
            }, 500);
            return () => clearTimeout(timeoutId);
          } else {
            setShowHearts(true);
          }
        }
      }
    }
  }, [isMainSequence, mainText, mainMessageIndex, isTyping]);

  const handleClick = () => {
    setShowButton(false);
    setTimeout(() => {
      setMainText('');
      setTimeout(() => {
        setIsMainSequence(true);
      }, 1000);
    }, 1000);
  };

  const HeartParticles = () => {
    return (
      <div className="heart-container">
        {[...Array(50)].map((_, i) => (
          <div 
            key={i} 
            className="floating-heart"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 4}s`,
              fontSize: `${Math.random() * 10 + 20}px`
            }}
          >
            ❤️
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="App">
      <div className="content">
        <h1 className={`main-text ${!showButton ? 'active' : ''}`}>
          <span className="text">{mainText}</span>
          {!showHearts && <span className="cursor">|</span>}
        </h1>
        {showButton && (
          <button className="main-button" onClick={handleClick}>
            <span className="button-text">{buttonText}</span>
            <span className="cursor">|</span>
          </button>
        )}
      </div>
      {showHearts && <HeartParticles />}
    </div>
  );
}

export default App;
